const formatNewRequest = (data) => {
  let result = {
    requestId: data.requestId,
    step: formatStep(data.step ?? ''),
    industry: data.industry ?? '',
    description: data.description ?? '',
    dueDate: data.dueDate ? data.dueDate : null,
    companyName: data.companyName ?? '',
    companyLogo: data.companyLogo ?? '',
    isUsePreBuildTemplate: data.isUsePreBuildTemplate ?? false,
    mainQuestions: formatCategoriesWithQuestions(data.mainQuestions ?? []),
    supplierQuestions: formatCategoriesWithQuestions(data.supplierQuestions ?? []),
    supplierAdditionalQuestions: formatCategoriesWithQuestions(data.supplierAdditionalQuestions ?? []),
    invitedSuppliers: formatInvitedSuppliers(data.invitedSuppliers ?? [])
  };
  return result;
};

const formatStep = (data = '') => {
  let result = 1;
  switch (data) {
    case 'Details':
      result = 1;
      break;
    case 'Questions For Suppliers':
      result = 2;
      break;
    case 'Invite Suppliers':
      result = 3;
      break;
    case 'Review & Submit':
      result = 4;
      break;
    default:
      result = 1;
      break;
  }
  return result;
};

const formatCategoriesWithQuestions = (data = []) => {
  let result = [];
  if (data?.length) {
    data.forEach((item) => {
      if (item?.categoryId) {
        result.push(formatCategory(item));
      }
    });
  }
  return result;
};

const formatCategory = (data = {}) => {
  return {
    categoryId: data?.categoryId,
    value: data?.value ?? '',
    type: data?.type ?? '',
    description: data?.description ?? '',
    questions: formatQuestions(data?.questions ?? [])
  };
};

const formatQuestions = (data = []) => {
  let result = [];
  if (data?.length) {
    data.forEach((item) => {
      if (item?.questionId) {
        result.push(formatQuestion(item));
      }
    });
  }
  return result;
};

const formatQuestion = (data = {}) => {
  return {
    questionId: data.questionId,
    value: data.value ?? '',
    fieldType: data.fieldType ?? '',
    isRequired: data.isRequired ?? false,
    clientAnswer: data.clientAnswer ?? '',
    documents: [],
    answer: formatSupplierAnswer(data?.answer ?? {})
  };
};

const formatSupplierAnswer = (data = {}) => {
  return {
    answerId: data?.answerId ?? '',
    supplierAnswer: data?.supplierAnswer ?? '',
    isNoBid: data?.isNoBid ?? false,
    noBidReason: data?.noBidReason ?? ''
  };
};

const formatInvitedSuppliers = (data = []) => {
  let result = [];
  if (data?.length) {
    data.forEach((item) => {
      if (item?.supplierId && item?.inviteId) {
        result.push(formatInvitedSupplier(item));
      }
    });
  }
  return result;
};

const formatInvitedSupplier = (data) => {
  return {
    supplierId: data?.supplierId,
    inviteId: data?.inviteId,
    lastName: data?.lastName ?? '-',
    firstName: data?.firstName ?? '-',
    email: data?.email ?? '',
    phoneNumber: data?.phoneNumber ?? '',
    status: data?.status ?? '',
    noBidReason: data?.noBidReason ?? '',
    totalAnswers: data?.totalAnswers ?? 0
  };
};

const formatDocuments = (data = []) => {
  let result = [];
  if (data?.length) {
    data.forEach((item) => {
      if (item?.documentId) {
        result.push(formatDocument(item));
      }
    });
  }
  return result;
};

const formatDocument = (data) => {
  return {
    documentId: data.documentId,
    documentSize: formatFileSize(data.documentSize ?? 0),
    documentTitle: data.documentTitle ?? '-',
    documentType: data.documentType ?? ''
  };
};

const formatFileSize = (size) => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

const formatRequests = (data = []) => {
  let result = [];
  if (data?.length) {
    data.forEach((item) => {
      if (item?.stage && item?.requestId) {
        result.push({
          name: item.name,
          stage: item.stage,
          requestId: item.requestId,
          industry: item.industry ?? '-',
          dueDate: item.dueDate ?? '-',
          totalSuppliers: item.totalSuppliers ?? 0
        });
      }
    });
  }
  return result;
};

const formatSuppliers = (data = []) => {
  let result = [];
  if (data?.length) {
    data.forEach((item) => {
      if (item?.supplierId) {
        result.push(formatSupplier(item));
      }
    });
  }
  return result;
};

const formatSupplier = (data) => {
  return {
    supplierId: data.supplierId,
    lastName: data.lastName ?? '-',
    firstName: data.firstName ?? '-',
    email: data.email ?? '',
    phoneNumber: data.phoneNumber ?? ''
  };
};

export {
  formatNewRequest,
  formatRequests,
  formatSuppliers,
  formatSupplier,
  formatDocuments,
  formatDocument,
  formatCategoriesWithQuestions,
  formatQuestions,
  formatQuestion,
  formatCategory,
  formatInvitedSuppliers,
  formatInvitedSupplier,
  formatSupplierAnswer
};
